document.querySelectorAll('.tuev-badge').forEach((badge) => {
    const header = badge.querySelector('.tuev-badge__header');
    const content = badge.querySelector('.tuev-badge__content');
    const inner = badge.querySelector('.tuev-badge__content-inner');
    let isAnimating = false;

    header.addEventListener('click', () => {
        if (isAnimating) return;
        isAnimating = true;

        const isOpen = badge.classList.contains('is-open');

        if (isOpen) {
            content.style.height = content.scrollHeight + 'px';
            requestAnimationFrame(() => {
                content.style.height = '0';
            });
            badge.classList.remove('is-open');
            content.addEventListener('transitionend', function handler() {
                isAnimating = false;
                content.removeEventListener('transitionend', handler);
            }, { once: true });
        } else {
            badge.classList.add('is-open');
            content.style.height = inner.offsetHeight + 'px';
            content.addEventListener('transitionend', function handler() {
                content.style.height = 'auto';
                isAnimating = false;
                content.removeEventListener('transitionend', handler);
            }, { once: true });
        }
    });
});
